import { withStyles } from "@material-ui/core/styles";
import { MenuItem } from "@material-ui/core";

import * as colors from "../../../theme/colors";

export const StyledTopMenuItem = withStyles({
  root: {
    color: colors.darkBlue900,
    fontSize: 16,
    fontWeight: 700,
    height: 65,
    minWidth: 185,
    display: "flex",
    justifyContent: "left",
    textTransform: "uppercase",
    background: colors.lightBlue,
    "&:hover": {
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: colors.darkBlue900,
      },
      background: "transparent",
      color: colors.darkThemeGreen,
    },
  },
})(MenuItem);
